import React from 'react'

import cn from 'classnames'
import PropTypes from 'prop-types'

import source from './loading-bubbles.svg'

export const LoadingBubbles = ({ altText, className }) => (
  <img
    className={cn(className)}
    src={source}
    alt={altText}
    role="status"
  />
)

LoadingBubbles.propTypes = {
  altText: PropTypes.string.isRequired,
  className: PropTypes.string,
}

LoadingBubbles.defaultProps = {
  altText: 'Loading',
}

export default LoadingBubbles
